/**
 * Why someone reports a public text, as stored in `BookFeedback.reportReason`,
 * with the label the report dialog, the moderation pages and the notification
 * email show. (Feedback with ratings came before reports, and remains in the
 * moderation pages.)
 */
export const labels = /** @type {const} */ ({
  offensive: "Offensive or inappropriate",
  copyright: "Copyright infringement",
  spam: "Spam or misleading",
  poorContent: "Not interesting or useful",
  languageErrors: "Language errors (grammar, spelling)",
  other: "Other",
});
